<template>
    <ul :class="[listClass]">
        <li v-for="item in menu" 
            :key="item.id" 
            :class="[
                itemClass, 
                item.children.length > 0 ? `${itemClass}--has-submenu` : null,
                open == item ? `${itemClass}--submenu-open` : null,
            ]">
            
            <link-component 
                v-if="item.children.length == 0"
                :link="item.url" 
                :title="item.label"
                :class="[linkClass]"
                :active-class="`${linkClass}--active`"
                :exact-active-class="`${linkClass}--exact-active`">
                {{ item.label }}
            </link-component>
            <a v-else
                href="javascript:;"
                :title="item.label"
                :class="[linkClass, linkClass + '--submenu-trigger']"
                @click.stop="openMenu(item)">
                {{ item.label }}
            </a>

            <ul v-if="item.children.length > 0" :class="[submenuClass]">
                <li v-for="subitem in item.children" :key="subitem.id" :class="[itemClass]">
                    <link-component 
                        :link="subitem.localized.external_url || (`/`+subitem.localized.uri.slug)" 
                        :title="subitem.localized.title"
                        :class="[linkClass]"
                        :active-class="`${linkClass}--active`"
                        :exact-active-class="`${linkClass}--exact-active`">
                        {{ subitem.localized.title }}
                    </link-component>
                </li>
            </ul>
        </li>
    </ul>
</template>
<script>
import http from 'axios'
export default {
    props: {
        name: {
            type: String,
            default: null,
        },
        pages: {
            type: Array,
            default: null,
        },
        listClass: {
            type: String,
            default: ''
        },
        itemClass: {
            type: String,
            default: ''
        },
        linkClass: {
            type: String,
            default: ''
        },
        submenuClass: {
            type: String,
            default: ''
        }
    },

    data() {
        return {
            menu: [],
            open: null,
        }
    },

    created() {
        if(this.name) {
            http.get('/api/menu/' + this.name).then(res => {
                if(res.data.items) {
                    this.menu = res.data.items.map(item => {
                        item['children'] = [];
                        return item;
                    });
                }
            });
        }
    },

    mounted() {
        document.addEventListener('click', () => this.open = null);
    },

    methods: {
        openMenu(item) {
            if(this.open == item) {
                this.open = null;
            } else {
                this.open = item;
            }
        }
    },

    watch: {
        pages() {
            this.menu = this.pages.map(page => {
                return {
                    id: page.id,
                    label: page.localized.title,
                    url: page.localized.external_url || '/' + page.localized.uri.slug,
                    children: page.children
                };
            });
        }
    }
}
</script>



// WEBPACK FOOTER //
// ../default-js/js/components/package/RF/CMS/Menu.vue